/* BeadznThreadz product page: smart gallery, immersive viewer, sticky ATC, delivery estimate,
   coupon copy, share, recommendations, recently viewed and frequently-bought-together. */
(function () {
  if (window.__bzProductLoaded) return;
  window.__bzProductLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const pad = (n) => String(n).padStart(2, '0');
  const onVariantChange = (cb) => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      return subscribe(PUB_SUB_EVENTS.variantChange, cb);
    }
    return () => {};
  };
  const pauseMedia = (scope) => {
    scope.querySelectorAll('video').forEach((v) => v.pause());
    scope.querySelectorAll('.js-youtube').forEach((f) =>
      f.contentWindow && f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    );
    scope.querySelectorAll('.js-vimeo').forEach((f) => f.contentWindow && f.contentWindow.postMessage('{"method":"pause"}', '*'));
  };

  /* =====================================================================
     Immersive viewer (fullscreen, pinch / double-tap / wheel zoom, swipe)
     ===================================================================== */
  class BzViewer {
    constructor(el) {
      this.el = el;
      this.strip = el.querySelector('.bz-viewer__strip');
      this.slides = Array.from(el.querySelectorAll('.bz-viewer__slide'));
      this.thumbs = Array.from(el.querySelectorAll('[data-bz-viewer-go]'));
      this.current = el.querySelector('[data-bz-viewer-current]');
      this.index = 0;
      this.state = { scale: 1, x: 0, y: 0 };
      this.pointers = new Map();
      this.bind();
    }

    bind() {
      this.el.addEventListener('click', (e) => {
        if (e.target.closest('[data-bz-viewer-close]')) return this.close();
        if (e.target.closest('[data-bz-viewer-prev]')) return this.go(this.index - 1);
        if (e.target.closest('[data-bz-viewer-next]')) return this.go(this.index + 1);
        const t = e.target.closest('[data-bz-viewer-go]');
        if (t) this.go(parseInt(t.dataset.bzViewerGo, 10));
      });
      this.onKey = (e) => {
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowRight') this.go(this.index + 1);
        else if (e.key === 'ArrowLeft') this.go(this.index - 1);
        else if (e.key === 'Tab') this.trap(e);
      };
      const stage = this.el.querySelector('.bz-viewer__stage');
      stage.addEventListener('pointerdown', this.down.bind(this));
      stage.addEventListener('pointermove', this.move.bind(this));
      stage.addEventListener('pointerup', this.up.bind(this));
      stage.addEventListener('pointercancel', this.up.bind(this));
      stage.addEventListener('dblclick', (e) => this.toggleZoom(e));
      stage.addEventListener(
        'wheel',
        (e) => {
          e.preventDefault();
          const next = Math.min(4, Math.max(1, this.state.scale * (e.deltaY < 0 ? 1.15 : 0.87)));
          this.zoomAt(next, e.clientX, e.clientY);
        },
        { passive: false }
      );
    }

    trap(e) {
      const f = Array.from(this.el.querySelectorAll('button:not([disabled])'));
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    open(index, opener) {
      this.opener = opener;
      this.el.hidden = false;
      document.documentElement.classList.add('bz-lock');
      requestAnimationFrame(() => this.el.classList.add('is-open'));
      this.go(index, true);
      document.addEventListener('keydown', this.onKey);
      const close = this.el.querySelector('[data-bz-viewer-close]');
      if (close) close.focus();
    }

    close() {
      this.el.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKey);
      document.documentElement.classList.remove('bz-lock');
      setTimeout(() => (this.el.hidden = true), reduceMotion ? 0 : 300);
      if (this.opener) this.opener.focus();
    }

    load(i) {
      const img = this.slides[i] && this.slides[i].querySelector('img[data-src]');
      if (img) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }
    }

    go(i, instant) {
      const count = this.slides.length;
      if (!count) return;
      this.resetZoom();
      this.index = (i + count) % count;
      this.load(this.index);
      this.load((this.index + 1) % count);
      this.load((this.index - 1 + count) % count);
      this.strip.style.transition = instant || reduceMotion ? 'none' : '';
      this.strip.style.transform = `translate3d(${-this.index * 100}%,0,0)`;
      if (this.current) this.current.textContent = this.index + 1;
      this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === this.index));
      const at = this.thumbs[this.index];
      if (at) at.scrollIntoView({ block: 'nearest', inline: 'center', behavior: instant ? 'auto' : 'smooth' });
    }

    get img() {
      return this.slides[this.index] && this.slides[this.index].querySelector('img');
    }

    apply(animate) {
      const img = this.img;
      if (!img) return;
      img.style.transition = animate && !reduceMotion ? 'transform .3s ease' : 'none';
      img.style.transform = `translate3d(${this.state.x}px, ${this.state.y}px, 0) scale(${this.state.scale})`;
      this.el.classList.toggle('is-zoomed', this.state.scale > 1.01);
    }

    resetZoom() {
      const img = this.img;
      this.state = { scale: 1, x: 0, y: 0 };
      if (img) {
        img.style.transform = '';
        img.style.transition = '';
      }
      this.el.classList.remove('is-zoomed');
    }

    clamp() {
      const img = this.img;
      if (!img) return;
      const r = img.getBoundingClientRect();
      const baseW = r.width / this.state.scale;
      const baseH = r.height / this.state.scale;
      const maxX = Math.max(0, (baseW * this.state.scale - baseW) / 2);
      const maxY = Math.max(0, (baseH * this.state.scale - baseH) / 2);
      this.state.x = Math.min(maxX, Math.max(-maxX, this.state.x));
      this.state.y = Math.min(maxY, Math.max(-maxY, this.state.y));
    }

    zoomAt(scale, cx, cy, animate) {
      const img = this.img;
      if (!img) return;
      const r = img.getBoundingClientRect();
      const ox = cx - (r.left + r.width / 2);
      const oy = cy - (r.top + r.height / 2);
      const ratio = scale / this.state.scale;
      this.state.x = (this.state.x - ox) * ratio + ox;
      this.state.y = (this.state.y - oy) * ratio + oy;
      this.state.scale = scale;
      if (scale <= 1) this.state = { scale: 1, x: 0, y: 0 };
      this.clamp();
      this.apply(animate);
    }

    toggleZoom(e) {
      if (this.state.scale > 1.01) {
        this.state = { scale: 1, x: 0, y: 0 };
        this.apply(true);
      } else {
        this.zoomAt(2.5, e.clientX, e.clientY, true);
      }
    }

    down(e) {
      if (e.target.closest('button')) return;
      this.el.querySelector('.bz-viewer__stage').setPointerCapture(e.pointerId);
      this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (this.pointers.size === 2) {
        const [a, b] = Array.from(this.pointers.values());
        this.pinch = { dist: Math.hypot(a.x - b.x, a.y - b.y), scale: this.state.scale };
      } else {
        this.drag = { x: e.clientX, y: e.clientY, sx: this.state.x, sy: this.state.y, t: Date.now() };
      }
    }

    move(e) {
      if (!this.pointers.has(e.pointerId)) return;
      this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (this.pointers.size === 2 && this.pinch) {
        const [a, b] = Array.from(this.pointers.values());
        const dist = Math.hypot(a.x - b.x, a.y - b.y);
        const next = Math.min(4, Math.max(1, (this.pinch.scale * dist) / this.pinch.dist));
        this.zoomAt(next, (a.x + b.x) / 2, (a.y + b.y) / 2);
        return;
      }
      if (!this.drag) return;
      const dx = e.clientX - this.drag.x;
      const dy = e.clientY - this.drag.y;
      if (this.state.scale > 1.01) {
        this.state.x = this.drag.sx + dx;
        this.state.y = this.drag.sy + dy;
        this.clamp();
        this.apply();
      } else {
        this.strip.style.transition = 'none';
        this.strip.style.transform = `translate3d(calc(${-this.index * 100}% + ${dx}px),0,0)`;
      }
    }

    up(e) {
      if (!this.pointers.has(e.pointerId)) return;
      this.pointers.delete(e.pointerId);
      if (this.pointers.size < 2) this.pinch = null;
      if (!this.drag || this.pointers.size) return;
      const dx = e.clientX - this.drag.x;
      const dy = e.clientY - this.drag.y;
      const quick = Date.now() - this.drag.t < 250 && Math.abs(dx) < 8 && Math.abs(dy) < 8;
      if (this.state.scale <= 1.01) {
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        else this.go(this.index);
      }
      if (quick && e.pointerType !== 'mouse') {
        const now = Date.now();
        if (this.lastTap && now - this.lastTap < 300) {
          this.toggleZoom(e);
          this.lastTap = 0;
        } else {
          this.lastTap = now;
        }
      }
      this.drag = null;
    }
  }

  /* =====================================================================
     Smart gallery
     ===================================================================== */
  class BzGallery extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.track = this.querySelector('.bz-gallery__track');
      if (!this.track) return;
      this.slides = Array.from(this.querySelectorAll('.bz-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-bz-thumb]'));
      this.dots = Array.from(this.querySelectorAll('.bz-gallery__dot'));
      this.counter = this.querySelector('[data-bz-current]');
      this.lens = this.querySelector('.bz-gallery__lens');
      this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));

      const viewerEl = document.getElementById(`BzViewer-${this.sectionId}`);
      if (viewerEl) {
        if (viewerEl.parentElement !== document.body) {
          document.querySelectorAll(`body > #BzViewer-${this.sectionId}`).forEach((old) => old !== viewerEl && old.remove());
          document.body.appendChild(viewerEl);
        }
        this.viewer = new BzViewer(viewerEl);
      }

      this.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-bz-thumb]');
        if (thumb) return this.goTo(parseInt(thumb.dataset.bzThumb, 10));
        if (e.target.closest('[data-bz-gallery-prev]')) return this.goTo(this.index - 1);
        if (e.target.closest('[data-bz-gallery-next]')) return this.goTo(this.index + 1);
        const zoomBtn = e.target.closest('[data-bz-gallery-zoom]');
        if (zoomBtn && this.viewer) {
          const active = this.slides[this.index] && this.slides[this.index].querySelector('[data-bz-viewer-open]');
          const first = this.querySelector('[data-bz-viewer-open]');
          const target = active || first;
          return this.viewer.open(target ? parseInt(target.dataset.bzViewerOpen, 10) : 0, zoomBtn);
        }
        const opener = e.target.closest('[data-bz-viewer-open]');
        if (opener && this.viewer) this.viewer.open(parseInt(opener.dataset.bzViewerOpen, 10), opener);
      });

      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.goTo(this.index + 1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.goTo(this.index - 1);
        }
      });

      this.observe();
      this.initScan();
      if (this.lens) this.initLens();

      if (this.index > 0 && !this.isGrid()) this.goTo(this.index, true);

      this.unsubscribe = onVariantChange(({ data }) => {
        if (!data || data.sectionId !== this.sectionId || !data.variant || !data.variant.featured_media) return;
        const i = this.slides.findIndex((s) => s.dataset.rawMediaId === String(data.variant.featured_media.id));
        if (i > -1) this.goTo(i);
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.io) this.io.disconnect();
    }

    isGrid() {
      return (this.classList.contains('bz-gallery--premium_grid') || this.classList.contains('bz-gallery--premium_stack')) && desktop.matches;
    }

    goTo(i, instant) {
      const count = this.slides.length;
      i = (i + count) % count;
      const slide = this.slides[i];
      if (!slide) return;
      if (this.isGrid()) {
        slide.scrollIntoView({ block: 'nearest', behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      } else {
        this.track.scrollTo({ left: slide.offsetLeft, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      }
      this.setActive(i);
    }

    setActive(i) {
      if (i === this.index && this.slides[i].classList.contains('is-active')) return;
      const prev = this.slides[this.index];
      if (prev && prev !== this.slides[i]) pauseMedia(prev);
      this.index = i;
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      this.thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      if (this.counter) this.counter.textContent = i + 1;
      const thumb = this.thumbs[i];
      if (thumb && thumb.parentElement) {
        const rail = thumb.parentElement;
        const top = thumb.offsetTop - rail.clientHeight / 2 + thumb.clientHeight / 2;
        const left = thumb.offsetLeft - rail.clientWidth / 2 + thumb.clientWidth / 2;
        rail.scrollTo({ top, left, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      this.scan(this.slides[i]);
    }

    observe() {
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(
        (entries) => {
          if (this.isGrid()) return;
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              this.setActive(this.slides.indexOf(entry.target));
            }
          });
        },
        { root: this.track, threshold: [0.6] }
      );
      this.slides.forEach((s) => this.io.observe(s));
    }

    initScan() {
      this.scanEnabled = this.hasAttribute('data-scan') && !reduceMotion;
      if (!this.scanEnabled) return;
      this.scan(this.slides[this.index]);
    }

    scan(slide) {
      if (!this.scanEnabled || !slide || slide.dataset.scanned) return;
      const img = slide.querySelector('img');
      if (!img) return;
      const run = () => {
        slide.dataset.scanned = 'true';
        slide.classList.add('is-scanning');
        setTimeout(() => slide.classList.remove('is-scanning'), 1600);
      };
      if (img.complete && img.naturalWidth) run();
      else img.addEventListener('load', run, { once: true });
    }

    initLens() {
      const zoom = parseFloat(this.dataset.lensZoom || '2.5');
      const stage = this.querySelector('.bz-gallery__stage');
      let active = null;
      let raf = 0;
      const hide = () => {
        this.lens.classList.remove('is-visible');
        active = null;
      };
      stage.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse' || !finePointer.matches) return;
        const zoomable = e.target.closest('.bz-gallery__zoomable');
        const img = zoomable && zoomable.querySelector('img');
        if (!img) return hide();
        if (active !== img) {
          active = img;
          const src = img.dataset.full || img.currentSrc || img.src;
          this.lens.style.backgroundImage = `url("${src}")`;
        }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = img.getBoundingClientRect();
          const sr = stage.getBoundingClientRect();
          const x = e.clientX - r.left;
          const y = e.clientY - r.top;
          if (x < 0 || y < 0 || x > r.width || y > r.height) return hide();
          const lw = this.lens.offsetWidth / 2;
          const lh = this.lens.offsetHeight / 2;
          this.lens.style.transform = `translate3d(${e.clientX - sr.left - lw}px, ${e.clientY - sr.top - lh}px, 0)`;
          this.lens.style.backgroundSize = `${r.width * zoom}px ${r.height * zoom}px`;
          this.lens.style.backgroundPosition = `${-(x * zoom - lw)}px ${-(y * zoom - lh)}px`;
          this.lens.classList.add('is-visible');
        });
      });
      stage.addEventListener('pointerleave', hide);
    }
  }
  if (!customElements.get('bz-gallery')) customElements.define('bz-gallery', BzGallery);

  /* =====================================================================
     Sticky add to cart
     ===================================================================== */
  class BzStickyAtc extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.form = document.getElementById(this.dataset.form);
      this.mainBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.select = this.querySelector('[data-bz-sticky-select]');
      this.btn = this.querySelector('[data-bz-sticky-add]');
      this.label = this.querySelector('[data-bz-sticky-label]');
      this.price = this.querySelector('[data-bz-sticky-price]');
      this.compare = this.querySelector('[data-bz-sticky-compare]');
      if (document.body !== this.parentElement) {
        document.querySelectorAll(`body > bz-sticky-atc[data-section="${this.sectionId}"]`).forEach((old) => old !== this && old.remove());
        document.body.appendChild(this);
        return;
      }
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      if (!this.mainBtn || !('IntersectionObserver' in window)) return;
      this.hidden = false;

      const footer = document.querySelector('.footer, footer, [class*="footer-group"]');
      let mainVisible = true;
      let footerVisible = false;
      const update = () => {
        const show = !mainVisible && !footerVisible && this.mainBtn.getBoundingClientRect().top < 0;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.documentElement.classList.toggle('bz-sticky-open', show);
        this.querySelectorAll('button, select').forEach((el) => (el.tabIndex = show ? 0 : -1));
      };
      new IntersectionObserver((e) => {
        mainVisible = e[0].isIntersecting;
        update();
      }).observe(this.mainBtn);
      if (footer) {
        new IntersectionObserver((e) => {
          footerVisible = e[0].isIntersecting;
          update();
        }).observe(footer);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
      if (this.btn.disabled && this.notifyEl()) this.setState(false);

      if (this.select) {
        this.select.addEventListener('change', () => this.syncFromSelect());
      }

      this.btn.addEventListener('click', async () => {
        if (this.btn.dataset.notify === 'true') {
          const notify = this.notifyEl();
          if (notify) notify.open();
          return;
        }
        if (this.select) {
          this.btn.classList.add('is-loading');
          try {
            await window.BZCart.add([{ id: this.select.value }], this.btn);
          } catch (err) {
            if (window.BZ) window.BZ.toast(err.message);
          }
          this.btn.classList.remove('is-loading');
        } else if (this.form) {
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
          else this.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });

      this.unsubscribe = onVariantChange(({ data }) => {
        if (!data || data.sectionId !== this.sectionId || !data.variant) return;
        if (this.select) {
          this.select.value = String(data.variant.id);
          this.syncFromSelect();
        } else {
          this.setState(data.variant.available, window.BZ ? window.BZ.money(data.variant.price) : '', data.variant.compare_at_price > data.variant.price ? window.BZ.money(data.variant.compare_at_price) : '');
        }
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    syncFromSelect() {
      const opt = this.select.selectedOptions[0];
      if (!opt) return;
      this.setState(!opt.disabled, opt.dataset.price, opt.dataset.compare);
    }

    notifyEl() {
      return document.querySelector(`bz-notify[data-section="${this.sectionId}"]`);
    }

    setState(available, price, compare) {
      if (price && this.price) this.price.textContent = price;
      if (this.compare) {
        this.compare.hidden = !compare;
        if (compare) this.compare.textContent = compare;
      }
      const notify = !available && this.notifyEl();
      this.btn.dataset.notify = notify ? 'true' : 'false';
      this.btn.disabled = !available && !notify;
      if (!this.label) return;
      if (notify) this.label.textContent = notify.dataset.label;
      else if (window.variantStrings) this.label.textContent = available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
    }
  }
  if (!customElements.get('bz-sticky-atc')) customElements.define('bz-sticky-atc', BzStickyAtc);

  /* =====================================================================
     Back in stock — "Notify me"
     ===================================================================== */
  class BzNotify extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.sectionId = this.dataset.section;
      this.toggleBtn = this.querySelector('[data-bz-notify-toggle]');
      this.panel = this.querySelector('.bz-notify__panel');
      this.form = this.querySelector('[data-bz-notify-form]');
      this.status = this.querySelector('[data-bz-notify-status]');
      this.request = this.querySelector('[data-bz-notify-request]');
      if (this.querySelector('[data-bz-notify-posted]')) this.expand(false);

      this.toggleBtn.addEventListener('click', () => (this.panel.hidden ? this.expand(true) : this.collapse()));
      this.form.addEventListener('submit', (e) => this.submit(e));

      this.unsubscribe = onVariantChange(({ data }) => {
        if (!data || data.sectionId !== this.sectionId) return;
        this.setVariant(data.variant);
      });
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    setVariant(variant) {
      const soldOut = !variant || !variant.available;
      const buy = document.querySelector(`[data-bz-buy="${this.sectionId}"]`);
      if (buy) buy.classList.toggle('is-soldout', soldOut);
      this.hidden = !soldOut;
      if (!soldOut) this.collapse();
      if (variant && this.request) {
        const url = `${this.dataset.origin}${window.location.pathname}?variant=${variant.id}`;
        this.request.value = `${this.dataset.productTitle} — ${variant.title} — ${url} — SKU: ${variant.sku || ''}`;
      }
      document.dispatchEvent(new CustomEvent('bz:notify:state', { detail: { sectionId: this.sectionId, soldOut } }));
    }

    expand(focus) {
      this.panel.hidden = false;
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      if (focus) {
        const email = this.form.querySelector('input[type="email"]');
        if (email) setTimeout(() => email.focus({ preventScroll: true }), 50);
      }
    }

    collapse() {
      this.panel.hidden = true;
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
    }

    open() {
      this.expand(true);
      const top = this.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0) - 24;
      window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    async submit(e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      const email = this.form.querySelector('input[type="email"]');
      if (email && !email.checkValidity()) {
        email.reportValidity();
        return;
      }
      const btn = this.form.querySelector('[type="submit"]');
      btn.setAttribute('aria-disabled', 'true');
      this.status.className = 'bz-notify__status';
      this.status.textContent = '';
      try {
        const res = await fetch(this.form.action, { method: 'POST', body: new FormData(this.form), credentials: 'same-origin' });
        if (/\/challenge/.test(res.url)) {
          HTMLFormElement.prototype.submit.call(this.form);
          return;
        }
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sameForm = doc.getElementById(this.form.id);
        const hasErrors = sameForm && sameForm.querySelector('.errors, .form__message--error, [class*="error"]');
        if (!res.ok || (hasErrors && !/contact_posted=true/.test(res.url))) throw new Error('failed');

        const newsletter = this.form.querySelector('[data-bz-notify-newsletter]');
        if (newsletter && newsletter.checked && email) {
          const fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('utf8', '✓');
          fd.append('contact[email]', email.value);
          fd.append('contact[tags]', 'newsletter');
          fetch(this.form.action, { method: 'POST', body: fd, credentials: 'same-origin' }).catch(() => {});
        }
        this.status.textContent = this.status.dataset.success;
        this.status.classList.add('is-ok');
        this.form.classList.add('is-done');
      } catch (err) {
        this.status.textContent = this.status.dataset.error;
        this.status.classList.add('is-error');
      } finally {
        btn.removeAttribute('aria-disabled');
      }
    }
  }
  if (!customElements.get('bz-notify')) customElements.define('bz-notify', BzNotify);

  /* =====================================================================
     Variant-driven block updates (stock urgency)
     ===================================================================== */
  onVariantChange(({ data }) => {
    if (!data || !data.html) return;
    const src = data.html.getElementById(`BzStock-${data.sectionId}`);
    const dest = document.getElementById(`BzStock-${data.sectionId}`);
    if (src && dest) {
      dest.className = src.className;
      const viewers = dest.querySelector('[data-bz-viewers]');
      dest.innerHTML = src.innerHTML;
      if (viewers) {
        const fresh = dest.querySelector('[data-bz-viewers]');
        if (fresh) fresh.replaceWith(viewers);
      }
    }
  });

  /* =====================================================================
     Delivery estimate + countdown + PIN code
     ===================================================================== */
  function addBusinessDays(date, days, skipSunday) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skipSunday && d.getDay() === 0) continue;
      added++;
    }
    return d;
  }
  function istNow() {
    const now = new Date();
    return new Date(now.getTime() + now.getTimezoneOffset() * 60000 + 330 * 60000);
  }
  function initDelivery(root) {
    root.querySelectorAll('[data-bz-delivery]:not([data-ready])').forEach((el) => {
      el.dataset.ready = 'true';
      const min = parseInt(el.dataset.min, 10) || 3;
      const max = parseInt(el.dataset.max, 10) || 7;
      const skip = el.dataset.skipSunday === 'true';
      const cutoff = parseInt(el.dataset.cutoff, 10);
      let fmt;
      try {
        fmt = new Intl.DateTimeFormat(el.dataset.locale || 'en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      } catch (e) {
        fmt = new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      }
      const now = istNow();
      const base = now.getHours() >= cutoff ? addBusinessDays(now, 1, skip) : now;
      const start = fmt.format(addBusinessDays(base, min, skip));
      const end = fmt.format(addBusinessDays(base, max, skip));
      el.dataset.start = start;
      el.dataset.end = end;
      const text = el.querySelector('[data-bz-delivery-text]');
      if (text && text.dataset.template) {
        text.innerHTML = text.dataset.template
          .replace('{start}', `<strong>${start}</strong>`)
          .replace('{end}', `<strong>${end}</strong>`);
      }
      const cd = el.querySelector('[data-bz-countdown]');
      if (cd && cd.dataset.template && !isNaN(cutoff)) {
        const tick = () => {
          const n = istNow();
          const target = new Date(n);
          target.setHours(cutoff, 0, 0, 0);
          const diff = target - n;
          if (diff <= 0 || (skip && n.getDay() === 0)) {
            cd.hidden = true;
            return;
          }
          const h = Math.floor(diff / 3600000);
          const m = Math.floor((diff % 3600000) / 60000);
          cd.hidden = false;
          cd.innerHTML = cd.dataset.template.replace('{time}', `<strong>${h}h ${pad(m)}m</strong>`);
        };
        tick();
        setInterval(tick, 30000);
      }
      const form = el.querySelector('[data-bz-pincode]');
      if (form) {
        const input = form.querySelector('input');
        const out = form.querySelector('.bz-pincode__result');
        try {
          const saved = localStorage.getItem('bz:pincode');
          if (saved && input) input.value = saved;
        } catch (e) {}
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const pin = (input.value || '').trim();
          out.classList.remove('is-ok', 'is-error');
          if (!/^[1-9][0-9]{5}$/.test(pin)) {
            out.textContent = out.dataset.error;
            out.classList.add('is-error');
            return;
          }
          const blocked = (out.dataset.blockedPrefixes || '')
            .split(/[\s,]+/)
            .filter(Boolean)
            .some((p) => pin.indexOf(p) === 0);
          if (blocked) {
            out.textContent = out.dataset.blocked;
            out.classList.add('is-error');
            return;
          }
          try {
            localStorage.setItem('bz:pincode', pin);
          } catch (err) {}
          out.innerHTML = out.dataset.ok
            .replace('{pincode}', `<strong>${pin}</strong>`)
            .replace('{start}', start)
            .replace('{end}', `<strong>${end}</strong>`);
          out.classList.add('is-ok');
        });
      }
    });
  }

  /* =====================================================================
     Copy coupon / share / viewers / size-link fallback
     ===================================================================== */
  async function copyText(text) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      ta.remove();
      return ok;
    }
  }
  document.addEventListener('click', async (e) => {
    const copy = e.target.closest('[data-bz-copy]');
    if (copy) {
      await copyText(copy.dataset.bzCopy);
      const label = copy.querySelector('[data-bz-copy-label]');
      const original = label ? label.textContent : '';
      copy.classList.add('is-copied');
      if (label) label.textContent = copy.dataset.copied;
      if (window.BZ) window.BZ.toast(copy.dataset.copied + ' ' + copy.dataset.bzCopy);
      setTimeout(() => {
        copy.classList.remove('is-copied');
        if (label) label.textContent = original;
      }, 2200);
      return;
    }
    const giftSave = e.target.closest('[data-bz-giftnote-save]');
    if (giftSave) {
      const drawer = giftSave.closest('.bz-drawer');
      const input = drawer && drawer.querySelector('[data-bz-giftnote-input]');
      const value = input ? input.value.trim() : '';
      const attrs = {};
      attrs[giftSave.dataset.attr || 'Gift message'] = value;
      giftSave.setAttribute('aria-disabled', 'true');
      try {
        if (window.BZCart) await window.BZCart.saveAttributes(attrs);
        if (window.BZ) window.BZ.toast(giftSave.dataset.saved);
        const wrap = drawer.closest('.bz-giftnote');
        const label = wrap && wrap.querySelector('[data-bz-giftnote-label]');
        if (label && value) label.textContent = label.dataset.added;
        if (window.BZ) window.BZ.closeDrawer(drawer);
      } finally {
        giftSave.removeAttribute('aria-disabled');
      }
      return;
    }
    const share = e.target.closest('[data-bz-share]');
    if (share) {
      const url = share.dataset.bzShare;
      if (navigator.share && !finePointer.matches) {
        try {
          await navigator.share({ title: share.dataset.title, url });
          return;
        } catch (err) {
          if (err && err.name === 'AbortError') return;
        }
      }
      await copyText(url);
      if (window.BZ) window.BZ.toast(share.dataset.copied);
    }
  });

  function initViewers(root) {
    root.querySelectorAll('[data-bz-viewers]:not([data-ready])').forEach((el) => {
      el.dataset.ready = 'true';
      const min = parseInt(el.dataset.min, 10) || 5;
      const max = Math.max(min + 1, parseInt(el.dataset.max, 10) || 15);
      const set = () => {
        const n = Math.floor(min + Math.random() * (max - min + 1));
        el.innerHTML = `<span class="bz-pulse" aria-hidden="true"></span>${el.dataset.text.replace('{count}', n)}`;
      };
      set();
      setInterval(set, 45000);
    });
  }

  function hideOrphanSizeLinks(root) {
    root.querySelectorAll('[data-bz-size-link]').forEach((btn) => {
      if (!document.getElementById(btn.dataset.bzOpen)) btn.hidden = true;
    });
  }

  /* =====================================================================
     Recommendations inside main-product (Complete the look)
     ===================================================================== */
  class BzRecs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded || !this.dataset.url) return;
      const load = () => {
        this.dataset.loaded = 'true';
        fetch(this.dataset.url)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const src = doc.getElementById(this.id);
            if (src && src.innerHTML.trim()) {
              this.innerHTML = src.innerHTML;
              this.classList.add('is-loaded');
              if (window.BZ) window.BZ.init(this);
            } else if (/intent=complementary/.test(this.dataset.url) && !this.dataset.fallback) {
              this.dataset.fallback = 'true';
              this.dataset.url = this.dataset.url.replace('intent=complementary', 'intent=related');
              delete this.dataset.loaded;
              load();
            } else {
              this.hidden = true;
            }
          })
          .catch(() => (this.hidden = true));
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            load();
          },
          { rootMargin: '300px 0px' }
        );
        io.observe(this);
      } else {
        load();
      }
    }
  }
  if (!customElements.get('bz-recs')) customElements.define('bz-recs', BzRecs);

  /* =====================================================================
     Recently viewed
     ===================================================================== */
  const RV_KEY = 'bz:recent';
  function readRecent() {
    try {
      const v = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function trackRecent() {
    const tag = document.querySelector('[data-bz-recently-viewed-track]');
    if (!tag) return;
    let handle;
    try {
      handle = JSON.parse(tag.textContent);
    } catch (e) {
      return;
    }
    if (!handle) return;
    const list = readRecent().filter((h) => h !== handle);
    list.unshift(handle);
    try {
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 16)));
    } catch (e) {}
  }

  class BzRecentlyViewed extends HTMLElement {
    connectedCallback() {
      const current = this.dataset.current;
      const limit = parseInt(this.dataset.limit || '8', 10);
      const handles = readRecent()
        .filter((h) => h !== current)
        .slice(0, limit);
      const section = this.closest('.shopify-section') || this;
      const designMode = window.Shopify && Shopify.designMode;
      if (!handles.length) {
        if (!designMode) section.hidden = true;
        return;
      }
      const list = this.querySelector('[data-bz-rv-list]');
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(
        handles.map((h) =>
          fetch(`${root}products/${encodeURIComponent(h)}?section_id=bz-product-mini`)
            .then((r) => (r.ok ? r.text() : ''))
            .catch(() => '')
        )
      ).then((results) => {
        const html = results
          .map((r) => {
            if (!r) return '';
            const doc = new DOMParser().parseFromString(r, 'text/html');
            const wrap = doc.querySelector('.shopify-section') || doc.body;
            const card = wrap && wrap.querySelector('.card-wrapper, .bz-mini');
            return card ? `<li class="grid__item">${wrap.innerHTML}</li>` : '';
          })
          .join('');
        if (!html) {
          if (!designMode) section.hidden = true;
          return;
        }
        list.innerHTML = html;
        this.classList.add('is-loaded');
        if (window.BZ) window.BZ.init(this);
      });
      const clear = this.querySelector('[data-bz-rv-clear]');
      if (clear) {
        clear.addEventListener('click', () => {
          try {
            localStorage.removeItem(RV_KEY);
          } catch (e) {}
          section.hidden = true;
        });
      }
    }
  }
  if (!customElements.get('bz-recently-viewed')) customElements.define('bz-recently-viewed', BzRecentlyViewed);

  /* =====================================================================
     Frequently bought together
     ===================================================================== */
  class BzFbt extends HTMLElement {
    connectedCallback() {
      if (this.dataset.url && !this.dataset.loaded) {
        this.dataset.loaded = 'true';
        this.load(this.dataset.url);
      } else {
        this.setup();
      }
    }

    load(url) {
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const src = doc.querySelector('[data-bz-fbt-recs]');
          const target = this.querySelector('[data-bz-fbt-recs]');
          if (src && target && src.querySelector('[data-bz-fbt-item]')) {
            target.replaceWith(src);
            this.setup();
          } else if (/intent=complementary/.test(url)) {
            this.load(url.replace('intent=complementary', 'intent=related'));
          } else {
            this.setup();
          }
        })
        .catch(() => this.setup());
    }

    setup() {
      const items = Array.from(this.querySelectorAll('[data-bz-fbt-item]'));
      if (items.length < 2) {
        const s = this.closest('.shopify-section');
        if (s && !(window.Shopify && Shopify.designMode)) s.hidden = true;
        return;
      }
      this.classList.add('is-ready');
      const total = this.querySelector('[data-bz-fbt-total]');
      const compare = this.querySelector('[data-bz-fbt-compare]');
      const btn = this.querySelector('[data-bz-fbt-add]');
      const countEl = this.querySelector('[data-bz-fbt-count]');
      const recalc = () => {
        let sum = 0;
        let cmp = 0;
        let count = 0;
        items.forEach((item) => {
          const cb = item.querySelector('input[type="checkbox"]');
          const sel = item.querySelector('select');
          const opt = sel ? sel.selectedOptions[0] : null;
          const price = parseInt(opt ? opt.dataset.price : item.dataset.price, 10) || 0;
          const cprice = parseInt(opt ? opt.dataset.compare : item.dataset.compare, 10) || price;
          item.classList.toggle('is-off', !cb.checked);
          const priceEl = item.querySelector('.bz-fbt__price');
          if (priceEl && window.BZ) priceEl.textContent = window.BZ.money(price);
          if (cb.checked) {
            sum += price;
            cmp += Math.max(cprice, price);
            count++;
          }
        });
        if (total) total.textContent = window.BZ ? window.BZ.money(sum) : sum / 100;
        if (compare) {
          compare.hidden = cmp <= sum;
          compare.textContent = window.BZ ? window.BZ.money(cmp) : cmp / 100;
        }
        if (countEl) countEl.textContent = count;
        if (btn) btn.disabled = count === 0;
      };
      this.addEventListener('change', recalc);
      recalc();
      if (btn) {
        btn.addEventListener('click', async () => {
          const payload = items
            .filter((item) => item.querySelector('input[type="checkbox"]').checked)
            .map((item) => {
              const sel = item.querySelector('select');
              return { id: sel ? sel.value : item.dataset.variant, quantity: 1 };
            });
          if (!payload.length) return;
          btn.classList.add('is-loading');
          try {
            await window.BZCart.add(payload, btn);
          } catch (err) {
            if (window.BZ) window.BZ.toast(err.message);
          }
          btn.classList.remove('is-loading');
        });
      }
    }
  }
  if (!customElements.get('bz-fbt')) customElements.define('bz-fbt', BzFbt);

  /* ===================================================================== */
  function init(root) {
    initDelivery(root);
    initViewers(root);
    hideOrphanSizeLinks(root);
  }
  const start = () => {
    const atc = document.querySelector('product-info [data-bz-atc-label]');
    if (atc && window.variantStrings) window.variantStrings.addToCart = atc.dataset.bzAtcLabel;
    trackRecent();
    init(document);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => init(document), 0));
  }
})();
